import { ShiftPostStep } from '@features/shift-post-v2/steps'
import AuthService from '@src/helpers/authService'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { SHIFT_PROGRESS, SHIFT_TYPE } from '@src/models/Shift'
import { FEATURE_TOGGLE_MULTIDAY_REVAMP } from '@src/config/featureToggles'
import { connect } from 'formik'
import { IShiftDetailsStepProps } from './shift-details-step.types'
import {
  SelectTemplateSection,
  PositionNameSection,
  ScheduleSection,
  AdditionalOptionsSection,
  LocationSection,
  UpshiftersNumberSection,
  ShiftIdentifierSection,
} from './components'
import { ShiftDetailsStepContainer } from './shift-details-step.styles'

const ShiftDetailsStepComponent = ({
  sourcePage,
  formik,
}: IShiftDetailsStepProps) => {
  const businessEntity = AuthService.getBusinessEntity()
  const shouldMinWageButtonShow = businessEntity?.must_be_min_age
  const isTrainingModeAllowed = businessEntity?.training_mode

  const shouldShowAdditionalOptionsSection =
    shouldMinWageButtonShow || isTrainingModeAllowed

  const values = formik?.values

  const isEditInProgressMultidayShift =
    Number(values?.type) === SHIFT_TYPE.MULTIDAY &&
    Number(values?.progress) === SHIFT_PROGRESS.ACTIVE &&
    FEATURE_TOGGLE_MULTIDAY_REVAMP &&
    sourcePage === ShiftPostPage.EDIT_SHIFT

  return (
    <ShiftDetailsStepContainer>
      {sourcePage === ShiftPostPage.POST_SHIFT && (
        <SelectTemplateSection
          sourceStep={ShiftPostStep.SHIFT_DETAILS}
          sourcePage={sourcePage}
          businessEntity={businessEntity}
        />
      )}
      {isEditInProgressMultidayShift ? null : (
        <>
          <PositionNameSection
            sourceStep={ShiftPostStep.SHIFT_DETAILS}
            sourcePage={sourcePage}
          />
          <ShiftIdentifierSection
            sourceStep={ShiftPostStep.SHIFT_DETAILS}
            sourcePage={sourcePage}
          />
          <UpshiftersNumberSection
            sourceStep={ShiftPostStep.SHIFT_DETAILS}
            sourcePage={sourcePage}
          />
          <LocationSection
            sourceStep={ShiftPostStep.SHIFT_DETAILS}
            sourcePage={sourcePage}
          />
        </>
      )}

      <ScheduleSection
        sourceStep={ShiftPostStep.SHIFT_DETAILS}
        sourcePage={sourcePage}
      />
      {shouldShowAdditionalOptionsSection && !isEditInProgressMultidayShift && (
        <AdditionalOptionsSection
          sourceStep={ShiftPostStep.SHIFT_DETAILS}
          sourcePage={sourcePage}
        />
      )}
    </ShiftDetailsStepContainer>
  )
}

export const ShiftDetailsStep = connect<IShiftDetailsStepProps>(
  ShiftDetailsStepComponent,
)
